jQuery(function ($) {
    var mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    $('.it-logos-slider').each(function () {
        var $slider = $(this);
        var $viewport = $slider.find('.it-logos-slider__viewport');
        var $tracks = $slider.find('.it-logos-slider__track');
        // Capped at 80px/s regardless of the widget's configured speed —
        // requested slower than whatever value is currently set in
        // Elementor, without needing admin access to change it there.
        var pixelsPerSecond = Math.min(parseFloat($slider.attr('data-speed')) || 120, 80);

        // The two-track technique only loops seamlessly if each track is at
        // least as wide as the viewport — otherwise the two tracks (which
        // move together as one rigid strip) run out of content right before
        // the loop restarts, leaving a brief gap at the edge. Cloning the
        // logo set within each track until it's wide enough fixes this
        // regardless of how many logos are configured or how wide the
        // screen is, instead of relying on there always being "enough".
        var ensureTrackWidth = function () {
            var viewportWidth = $viewport[0].getBoundingClientRect().width;

            $tracks.each(function () {
                var $track = $(this);

                // Idempotent: drop any clones from a previous run (e.g. an
                // earlier, narrower viewport) before re-measuring, so this
                // can be called again on every image load / resize without
                // compounding.
                $track.find('.it-logos-slider__item--clone').remove();

                var $originalItems = $track.find('.it-logos-slider__item');

                if (!$originalItems.length) {
                    return;
                }

                var guard = 0;

                while ($track[0].getBoundingClientRect().width < viewportWidth && guard < 20) {
                    $originalItems.clone().addClass('it-logos-slider__item--clone').appendTo($track);
                    guard++;
                }
            });
        };

        // The CSS animation travels exactly one track width per cycle, so the
        // duration that yields a constant px/sec speed is width / speed.
        var applyDuration = function () {
            var trackWidth = $tracks.first()[0].getBoundingClientRect().width;

            if (!trackWidth) {
                return;
            }

            $slider[0].style.setProperty('--it-logos-slider-duration', (trackWidth / pixelsPerSecond) + 's');
        };

        var refresh = function () {
            ensureTrackWidth();
            applyDuration();
        };

        var applyMotionPreference = function () {
            $slider.toggleClass('it-logos-slider--static', mediaQuery.matches);
        };

        refresh();
        applyMotionPreference();

        // Track width depends on the logo images, which are still decoding on
        // first paint, and on the viewport width after a resize.
        $slider.find('img').on('load', refresh);
        $(window).on('resize', refresh);

        if (mediaQuery.addEventListener) {
            mediaQuery.addEventListener('change', applyMotionPreference);
        }
    });
});
